import React from "react";
import { WorkflowProvider } from "contexts/components";

type Props = {
  initData?: any;
  children: React.ReactNode;
};

export const Wrapper = ({ initData, children }: Props) => {
  return <WorkflowProvider initData={initData}>{children}</WorkflowProvider>;
};
